import { Injectable } from '@angular/core';
import {
  Exporter,
  ExportType,
  Options,
  ServiceLocatorService,
} from 'mat-table-exporter';
import { Company } from '../models';
import { AuthService } from '../../modules/auth';
import { LayoutService } from '../../modules/layout';
@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor(
    private serviceLocator: ServiceLocatorService,
    private authService: AuthService,
    private layout: LayoutService
  ) {}
  private _exporterService: Exporter<Options>;
  exportCompanyReport(
    data: Company[],
    format: ExportType | 'xls' | 'xlsx' | 'csv' | 'txt' | 'json' | 'other',
    fileName = 'FFA - Boards Export'
  ) {
    if (!this.authService.hasActivePlan(['pro', 'enterprise'])) {
      this.layout.showPaywall('Unlock Premium to Access Exporting Features');
      return;
    }

    if (!this._exporterService) {
      this._exporterService = this.serviceLocator.getService(format);
    }

    // const data = [...this.displayedColumns];
    const content: any = data.map(company => {
      if (company.is_premium) {
        return {
          name: company.issuer_name,
          average_age: company.average_age,
          overall: 'Subscription required',
          ebitda: 'Subscription required',
          carbon_intensity: 'Subscription required',
          tsr: 'Subscription required',
          controversies: 'Subscription required',
          gender_influence_gap: 'Subscription required',
          diversity_influence_gap: 'Subscription required',
        };
      } else {
        return {
          name: company.issuer_name,
          average_age: company.average_age,
          overall: company.team_power,
          ebitda: company.weighted_ebitda_win_rate,
          carbon_intensity: company.weighted_carbon_win_rate,
          tsr: company.weighted_tsr_win_rate,
          controversies: company.controversy_win_rate,
          gender_influence_gap: company.gender_influence_gap / 100,
          diversity_influence_gap: company.diversity_influence_gap / 100,
        };
      }
    });

    content.unshift({
      name: 'Name',
      average_age: 'Average Age',
      overall: 'Overall',
      ebitda: 'EBITDA',
      carbon_intensity: 'Carbon Intensity',
      tsr: 'TSR',
      controversies: 'Controversies',
      gender_influence_gap: 'Gender Influence Gap',
      diversity_influence_gap: 'Diversity Influence Gap',
    });

    this._exporterService.export(content, {
      fileName,
    });
  }
}
